import { Flex } from "@chakra-ui/react"

import { SHARED_DATA_TYPE } from "@/domain/sharedData/constants"
import type { GetUserSharedDatasParams } from "@/networking/api"

import { useSharedDataModals } from "../TableInterBU/useSharedDataModals"
import { TableLayout } from "../TableLayout/TableLayout"
import { useGetInfiniteQuery } from "../TableLayout/hook/useGetInfiniteQuery"
import { InterBUShareCard } from "./InterBUShareCard"
import type { InterBUDirection } from "./cardRules"

type Props = {
  direction: InterBUDirection
  // Search and filters of the toolbar, already restricted to this direction's keys.
  filters: GetUserSharedDatasParams
  currentSearchTerm?: string
}

// One tab of the InterBU page (ADR 0009, D3): the server applies the user's perimeter for this
// direction, so the rows are shown as they come, with infinite scroll.
export const InterBUCardList: React.FC<Props> = ({ direction, filters, currentSearchTerm }) => {
  const { items, query, fetchNextPage, hasNextPage, isLoading } = useGetInfiniteQuery({
    ...filters,
    "type.code": SHARED_DATA_TYPE.INTER_BU,
    direction,
  })

  // The detail modal names the requestor's side "to" (ShareResponseModal, SharedTable).
  const { openDetails, openAccept, openDecline, openCancelShare, modals } = useSharedDataModals(
    items,
    direction === "sent" ? "to" : "from",
    () => void query.refetch()
  )

  return (
    <>
      <TableLayout
        currentSearchTerm={currentSearchTerm}
        items={items}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingData={isLoading}
      >
        <Flex direction="column" gap="3">
          {items?.map(share => (
            <InterBUShareCard
              key={share.id}
              share={share}
              direction={direction}
              onOpenDetails={openDetails}
              onAccept={openAccept}
              onDecline={openDecline}
              onCancel={openCancelShare}
            />
          ))}
        </Flex>
      </TableLayout>
      {modals}
    </>
  )
}
